import values from "lodash/values"

import {
  ChatMessageAction,
  ChatMessageActionTypes,
  IMessage,
  Sender,
  INode,
  INodeList, 
  ReactionItemType
} from "./types"

const generateId = () =>
  Math.random()
    .toString(36)
    .substr(2, 9);

const defaultState: IMessage[] = [
  {
    message_id: "message-root",
    chatdata_id: "",
    type: Sender.OPERATOR,
    text: "",
  },
]
let chatBotBaseDataArray: INode[]
export default function chatMessageReducer(
  state = defaultState,
  action: ChatMessageActionTypes
) {
  switch (action.type) {
    case ChatMessageAction.FETCH_CHATBOT_DATA_SUCCESS:
      // baseデータをチャットボットから変更することはないのでstateとして外に出していない
      // 使いにくければ出す
      chatBotBaseDataArray = Object.values(action.payload.chatbotData)
      let initialNode: INode[] = chatBotBaseDataArray.filter(
        (item) => item.isRoot === true
      )
      return [
        {
          message_id: "message-root",
          chatdata_id: initialNode[0].id,
          type: Sender.OPERATOR,
          text: initialNode[0].content,
        },
      ]
    case ChatMessageAction.START_CHATBOT:
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: "element-root",
          type: "operator",
          text: action.payload.message,
        },
      ]
    case ChatMessageAction.RETURN_ROOT_MESSAGE:
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: `element-${generateId()}`,
          type: Sender.OPERATOR,
          text: `最初の質問に戻りますか？`,
          return_btn: true,
        },
      ]
    case ChatMessageAction.RETURN_ROOT:
      const rootNode: INode[] = chatBotBaseDataArray.filter(
        (item) => item.isRoot === true
      )
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: rootNode[0].id,
          type: Sender.OPERATOR,
          text: rootNode[0].content,
        },
      ]

    case ChatMessageAction.RETURN_PREV_QUESTION:
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: action.payload.data.id,
          prev_id: "",
          type: Sender.OPERATOR,
          text: action.payload.data.content,
        },
      ]

    case ChatMessageAction.END_MESSAGE:
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: `element-${generateId()}`,
          type: Sender.OPERATOR,
          text: action.payload.message,
          return_btn: true,
        },
      ]

    case ChatMessageAction.ADD_MESSAGE:
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: action.payload.id,
          type: action.payload.type,
          text: action.payload.text,
        },
      ]

    case ChatMessageAction.REPLY_MESSAGE:
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          prev_id: action.payload.prev_id,
          chatdata_id: action.payload.id,
          type: action.payload.type,
          text: action.payload.text,
          chatImages: action.payload.chatImages,
          like_btn:
            action.payload.reactionType === ReactionItemType.OPERATOR_ANSWER
              ? true
              : false
        }
      ];
    case ChatMessageAction.FETCH_KEYWORD_DATA_REQUEST:
      const AnswerMessage = "回答を検索しています"
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: `element-${generateId()}`,
          type: Sender.OPERATOR,
          text: `「${action.payload.message}」
					について${AnswerMessage}`,
        },
      ]
    case ChatMessageAction.FETCH_KEYWORD_DATA_SUCCESS:
      return searchMessageDataIncludeKeywords(
        state,
        action.payload.keywords,
        action.payload.chatbasedata
      )

    case ChatMessageAction.FETCH_KEYWORD_DATA_FAILURE:
      return [
        ...state,
        {
          message_id: `element-${generateId()}`,
          chatdata_id: `element-${generateId()}`,
          type: Sender.OPERATOR,
          text: `質問を受け取ることができませんでした。
					時間を置いてお試しください`,
        },
      ]
    default:
      return state
  }
}

const searchMessageDataIncludeKeywords = (
  state: IMessage[],
  keywords: string[],
  chatbasedata: INodeList
) => {
  const chatBotBaseDataArray = values(chatbasedata)

  // web, Webのようなパターンを同一にするため全部大文字で比較
  const uppserCaseKeywords = keywords.map((keyword) => keyword.toUpperCase())
  const searchData = chatBotBaseDataArray.filter((data) => {
    if (typeof data.keyword !== "undefined" && data.keyword.length > 0) {
      const filterData = data.keyword.filter((keyword) => {
        if (uppserCaseKeywords.includes(keyword.toUpperCase())) {
          return data
        }
        return null
      })
      if (filterData.length > 0) return true
      return false
    }
    return null
  })

  let answerMessage: IMessage
  let resultMessage: IMessage[]
  if (searchData.length > 0) {
    answerMessage = {
      message_id: `element-${generateId()}`,
      chatdata_id: `element-${generateId()}`,
      type: Sender.OPERATOR,
      text: "以下の回答が見つかりました",
    }
    resultMessage = searchData.map((data) => ({
      message_id: `element-${generateId()}`,
      chatdata_id: data.id,
      type: Sender.OPERATOR,
      text: data.content,
    }))
  } else {
    const rootNode: INode[] = chatBotBaseDataArray.filter(
      (item) => item.isRoot === true
    )
    answerMessage = {
      message_id: `element-${generateId()}`,
      chatdata_id: `element-${generateId()}`,
      type: Sender.OPERATOR,
      text: "回答を見つけることができませんでした",
    }
    resultMessage = [
      {
        message_id: `element-${generateId()}`,
        chatdata_id: rootNode[0].id,
        type: Sender.OPERATOR,
        text: rootNode[0].content,
      },
    ]
  }

  return [...state, answerMessage, ...resultMessage]
}
